import React from 'react';

import CloseButton from 'iss/widgets/bootstrap/CloseButton';

export function Modal({visible, title, onClose, children, size}) {
  const sizeClass = size == "large" ? "modal-lg" : (size == "small" ? "modal-sm" : null);
  const classes = "modal fade" + (visible ? " in" : "");
  const backdropClasses = "modal-backdrop fade" + (visible ? " in" : "");
  const style = {display: visible ? "block" : "none", overflow: "auto"};
  const backdropStyle = {bottom: visible ? "0" : "100%"};
  return <React.Fragment>
    <div className={classes} tabIndex="-1" role="dialog" style={style} onClick={onClose}>
      <div className={"modal-dialog "+sizeClass} role="document">
        <div className="modal-content" onClick={(e) => e.stopPropagation() /* Do not fire the onClose handler */}>
          {onClose || title ?
              <div className="modal-header">
                {onClose && <CloseButton onClick={onClose} /> }
                <h4 className="modal-title">{title}</h4>
              </div> : null
          }
          {React.isValidElement(children) || children instanceof Array ? children: <ModalContents>{children}</ModalContents>}
        </div>
      </div>
    </div>
    <div className={backdropClasses} style={backdropStyle}/>
  </React.Fragment>;
}

function ModalBody({children}) {
  return <div className="modal-body">
    {children}
  </div>;
}

function ModalFooter({children}) {
  return <div className="modal-footer">
    {children}
  </div>;
}

/** A utility component to make some modal content fragments look less
  * unwieldy. Takes modal contents in the form of an object: {body, footer} */
function ModalContents({children}) {
  return <React.Fragment>
    <ModalBody>
      {children.body}
    </ModalBody>
    {children.footer &&
        <ModalFooter>
          {children.footer}
        </ModalFooter>
    }
  </React.Fragment>;
}

Modal.Body = ModalBody;
Modal.Footer= ModalFooter;
Modal.Contents = ModalContents;

export default Modal;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/Modal.jsx